'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _props2 = require('../props');

var _common = require('../../common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toolbox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(Toolbox, _Component);

  function Toolbox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Toolbox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toolbox.__proto__ || (0, _getPrototypeOf2.default)(Toolbox)).call.apply(_ref, [this].concat(args))), _this), _this._changeProperty = function (property, value) {
      var _this$props = _this.props,
          changeProperty = _this$props.changeProperty,
          id = _this$props.id;


      if (typeof changeProperty === 'function') {
        changeProperty(id, property, value, _this.props[property]);
      }
    }, _this._onChangeProperty = function (event) {
      var target = event.target;
      _this._changeProperty(target.name, target.value);
    }, _this._onChangeColor = function (color, property) {
      var _color = color.hex;
      _this._changeProperty(property, _color);
    }, _this._onChangeFontStyle = function (property, value, values) {
      var stylesValues = _common.mapFontStyles.toStyles(values);
      var _property = _common.mapFontStyles.PROPS_STYLES_MAP[property];
      _this._changeProperty(_property, stylesValues[_property]);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Toolbox, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          id = _props.id,
          backgroundColor = _props.backgroundColor,
          color = _props.color,
          fontSize = _props.fontSize,
          fontWeight = _props.fontWeight,
          fontStyle = _props.fontStyle,
          textDecoration = _props.textDecoration,
          fontFamily = _props.fontFamily;

      var fontStylesProps = _common.mapFontStyles.toProps({ fontWeight: fontWeight, fontStyle: fontStyle, textDecoration: textDecoration });
      var styles = require('./Toolbox.scss');

      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(className, styles.root) },
        _react2.default.createElement(
          _common.ToolboxSection,
          { className: (0, _classnames2.default)(styles.section, styles.colors), header: 'COLORS' },
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(styles.row, styles.colorPicker) },
            _react2.default.createElement(_components.ColorPickerWrap, {
              color: color,
              disableAlpha: true,
              onChangeComplete: function onChangeComplete(newColor) {
                return _this2._onChangeColor(newColor, 'color');
              }
            }),
            _react2.default.createElement(
              'label',
              { className: styles.label, htmlFor: 'tq-plus-admin-' + id + '-font-color' },
              'Font Color'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _classnames2.default)(styles.row, styles.colorPicker) },
            _react2.default.createElement(_components.ColorPickerWrap, {
              color: backgroundColor,
              disableAlpha: true,
              onChangeComplete: function onChangeComplete(newColor) {
                return _this2._onChangeColor(newColor, 'backgroundColor');
              }
            }),
            _react2.default.createElement(
              'label',
              { className: styles.label, htmlFor: 'tq-plus-admin-' + id + '-background-color' },
              'Background Color'
            )
          )
        ),
        _react2.default.createElement(
          _common.ToolboxSection,
          { className: (0, _classnames2.default)(styles.section, styles.font), header: 'FONT' },
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            { className: styles.row },
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { className: styles.fontFamily, xs: 12 },
              _react2.default.createElement(
                'label',
                { className: styles.label, htmlFor: 'tq-plus-admin-' + id + '-font-family' },
                'FAMILY'
              ),
              _react2.default.createElement(_components.FontFamilyPicker, {
                name: 'fontFamily',
                value: fontFamily,
                fill: true,
                onChange: this._onChangeProperty
              })
            )
          ),
          _react2.default.createElement(
            _components.EnterpriseGrid.Row,
            { className: styles.row },
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { className: styles.fontSize, xs: 12, sm: true },
              _react2.default.createElement(
                'label',
                { className: styles.label, htmlFor: 'tq-plus-admin-' + id + '-font-size' },
                'Size'
              ),
              _react2.default.createElement(_components.PixelsInput, {
                value: fontSize,
                name: 'fontSize',
                fill: true,
                guide: false,
                controls: true,
                onChange: this._onChangeProperty
              })
            ),
            _react2.default.createElement(
              _components.EnterpriseGrid.Col,
              { className: styles.fontStyle, xs: 12, sm: true },
              _react2.default.createElement(
                'label',
                { className: styles.label, htmlFor: 'tq-plus-admin-' + id + '-font-style' },
                'STYLE'
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_components.FontStylePicker, {
                  className: styles.fontStylePicker,
                  classNameItem: styles.fontStylePickerItem,
                  classNameItemActive: styles.fontStylePickerItemActive,
                  values: fontStylesProps,
                  onChange: this._onChangeFontStyle
                })
              )
            )
          )
        )
      );
    }
  }]);
  return Toolbox;
}(_react.Component), _class.propTypes = _props2.propTypes, _class.defaultProps = _props2.defaultProps, _temp2);
exports.default = Toolbox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/InputText/Toolbox/Toolbox.jsx
// module id = 1538
// module chunks = 0